import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ea15dc96&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ea15dc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea15dc96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea15dc96')) {
      api.createRecord('ea15dc96', component.options)
    } else {
      api.reload('ea15dc96', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ea15dc96&scoped=true&", function () {
      api.rerender('ea15dc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2twYD7uYoT5DR/JS/comp/GuestBox.vue"
export default component.exports